import { action } from 'typesafe-actions'

import { Organization, Policy, User } from 'src/types'
import { MeActionTypes } from './types'

export const acceptUpdatedTerms = () =>
  action(MeActionTypes.ACCEPT_UPDATED_TERMS)

export const changePassword = (password: string) =>
  action(MeActionTypes.CHANGE_PASSWORD, { password })
export const changePasswordFailure = () =>
  action(MeActionTypes.CHANGE_PASSWORD_FAILURE)
export const changePasswordSuccess = () =>
  action(MeActionTypes.CHANGE_PASSWORD_SUCCESS)

export const generateQRCode = () => action(MeActionTypes.GENERATE_QRCODE)
export const generateQRCodeFailure = () =>
  action(MeActionTypes.GENERATE_QRCODE_FAILURE)
export const generateQRCodeSuccess = (qrCode: string) =>
  action(MeActionTypes.GENERATE_QRCODE_SUCCESS, { qrCode })

export const getMe = () => action(MeActionTypes.GET_ME)
export const getMeFailure = () => action(MeActionTypes.GET_ME_FAILURE)
export const getMeSuccess = (user: User) =>
  action(MeActionTypes.GET_ME_SUCCESS, { user })

export const getOrganization = () => action(MeActionTypes.GET_ORGANIZATION)
export const getOrganizationFailure = () =>
  action(MeActionTypes.GET_ORGANIZATION_FAILURE)
export const getOrganizationSuccess = (organization: Organization) =>
  action(MeActionTypes.GET_ORGANIZATION_SUCCESS, { organization })

export const getPolicy = () => action(MeActionTypes.GET_POLICY)
export const getPolicyFailure = () => action(MeActionTypes.GET_POLICY_FAILURE)
export const getPolicySuccess = (policy: Policy) =>
  action(MeActionTypes.GET_POLICY_SUCCESS, { policy })
